<template>
    <Modal v-if="showModal" modal-title="Session Expired" :show-close-btn="false">
        <template v-slot:body>
            <p>It seems like your current session has been expired, you have to re-login in order to continue.</p>
        </template>
        <template v-slot:footer>
            <a class="btn btn-primary float-right" href="/login">Go to Login <i class="fa fa-sign-in"></i></a>
        </template>
    </Modal>
</template>

<script>
export default {
    data() {
        return {
            showModal: false
        };
    },

    mounted() {
        window.yagankar.bus.addListener('session-expired', () => {
            this.showModal = true;
        });
    }
};
</script>
